import React from 'react';

import { useAppSelector, useAppDispatch } from '../../../redux/hooks';

import { Layout, Tree, Button } from 'antd';
import * as common from 'libs/common';

const WithInfoLNB = (props:any) => {
    const {Sider}  = Layout;
    const lnbCollapsed    = useAppSelector((state) => state.Frame.lnbCollapsed);
    const lnbMenuItems    = useAppSelector((state) => state.Frame.lnbMenuItems);
    const lnbWidth        = useAppSelector((state) => state.Frame.lnbWidth);
    const activeKey       = useAppSelector((state) => state.Frame.activeKey);
    const { DirectoryTree } = Tree;

    return (
        <Sider width={lnbWidth} collapsed={lnbCollapsed} style={{height:'100%'}}>
            <>
                {!lnbCollapsed ?
                <>
                    <Button block size='middle' className='background-color-primary-button' style={{flex: 1, padding: '0', margin: '0', boxSizing: 'border-box'}} onClick={() => {
                        if (activeKey === 'MCOM2021008') {
                            const param = {
                                title : '위드정보 확인',
                                contents: '현재 페이지 입니다.',
                            };
                            common.openAlert(param);
                        } else {
                            common.openPage({menuId:'MCOM2021008'});
                        }
                    }}><h3 style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'black', color: '#fff'}}>게시글쓰기</h3></Button>
                    <DirectoryTree
                        multiple
                        defaultExpandAll
                        onSelect={item => {
                            const param = { menuId : item[0] as string };
                            common.openPage(param);
                        }}
                        treeData={lnbMenuItems}
                        style={{height:'100%'}}
                        selectedKeys={[activeKey]}
                    />
                </>
                : null}
            </>
        </Sider>
    );
}

export default WithInfoLNB;